import Media from "@components/Media"
import React from "react"

import { ContentfulContentBaseProps } from "../types"

interface ContentfulMediaProps extends ContentfulContentBaseProps {}

const ContentfulMedia: React.FC<ContentfulMediaProps> = ({
  autoplayVideo,
  blockId,
  caption,
  customVideoThumbnail,
  fullWidth,
  gif,
  image,
  mobileGif,
  mobileImage,
  mobileVideoUrl,
  muxMobileVideo,
  muxVideo,
  type,
  videoThumbnail,
  videoUrl,
  wistiaVideoId,
  youtubeVideoId,
}) => {
  return (
    <Media
      autoplayVideo={autoplayVideo}
      blockId={blockId}
      caption={caption}
      customVideoThumbnail={customVideoThumbnail?.file?.url}
      fullWidth={fullWidth}
      gif={gif?.file?.url}
      image={image?.file?.url}
      mobileGif={mobileGif?.file?.url}
      mobileImage={mobileImage?.file?.url}
      mobileVideoUrl={mobileVideoUrl}
      muxMobileVideo={muxMobileVideo}
      muxVideo={muxVideo}
      type={type}
      videoThumbnail={videoThumbnail}
      videoUrl={videoUrl}
      wistiaVideoId={wistiaVideoId}
      youtubeVideoId={youtubeVideoId}
    />
  )
}

export default ContentfulMedia
